import React, { PureComponent } from "react";
import { Form } from "react-bootstrap";
import { get, filter, debounce } from "lodash";
import { AutoSuggestSelect } from "../../component/AutoSuggestSelect";
import { ERROR_MSG, STATUS } from "../../constant";
import {
  getAutoCompleteListAction,
  shouldDeletePPAction,
  getAutoCompleteListUserAction
} from "../../actions/createProject.action";
import { isValidArray } from "../../helper";
import { toast } from "react-toastify";
import queryString from "query-string";
import { successToastStyle, errorToastStyle } from "../../customToast";

export class OtherPP extends PureComponent {
  state = {
    otherPP: [{}],
    otherPPerror: "",
    otherPPusererror: false,
    autoSuggestApiLoading: [],
    defaultSelected: [],
    options: [],
    error: [{}],
    redBorder: false,
    index: "",
    clickflag: false
  };

  componentDidMount() {
    const { otherPP, isStateDepartment, isStatePMG } = this.props;

    let _otherPP =
      otherPP && otherPP.length
        ? otherPP.map(value => {
            return {
              otherPP: value
            };
          })
        : null;

    if (_otherPP !== null) {
      if (isStateDepartment || isStatePMG) {
        let _defaultSelected = [...otherPP].map(value => {
          return `${value.name} (${value.organization})`;
        });

        this.setState({
          otherPP: [..._otherPP],
          defaultSelected: [..._defaultSelected]
        });
      } else {
        let _defaultSelected = [...otherPP].map(value => {
          return `${value.name} (${value.userID})`;
        });

        this.setState({
          otherPP: [..._otherPP],
          defaultSelected: [..._defaultSelected]
        });
      }
    }
  }

  onRemovePP = async index => {
    const {
      updateParentState,
      updateParentStateError,
      projectId,
      OtherPPBlur: triggerBlur
    } = this.props;
    const { otherPP, defaultSelected } = this.state;

    let params =
      otherPP[index] && otherPP[index].otherPP && otherPP[index].otherPP.id;

    const isProjectDuplicateResp = params
      ? await shouldDeletePPAction(params, projectId)
      : { data: true };

    if (isProjectDuplicateResp && isProjectDuplicateResp.data) {
      this.setState(
        prevState => {
          prevState.otherPP.splice(index, 1);
          prevState.error.splice(index, 1);
          let _otherPP =
            prevState.otherPP &&
            prevState.otherPP.length &&
            prevState.otherPP.map(item => {
              return item.otherPP;
            });
          let _defaultSelected = defaultSelected;
          _defaultSelected.splice(index, 1);
          //_defaultSelected[index] = "";
          updateParentState("otherPP", _otherPP);
          updateParentStateError("otherPP", prevState.error);
          return {
            otherPP: [...prevState.otherPP],
            error: [...prevState.error],
            defaultSelected: _defaultSelected
          };
        },
        () => {
          const hasErrorMessage = otherPP.some(item =>
            item.hasOwnProperty("errorMessage")
          );
          if (hasErrorMessage && typeof triggerBlur === "function") {
            triggerBlur(true);
          } else {
            triggerBlur(false);
          }
        }
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">
          User cannot be deleted.Contains related data
        </p>,
        errorToastStyle
      );
    }
  };

  onAddPP = () => {
    const { updateParentState, updateParentStateError } = this.props;

    this.setState(
      prevState => {
        return {
          otherPP: [...prevState.otherPP, {}],
          error: [{}, ...prevState.error]
        };
      },
      () => {
        let _otherPP =
          this.state.otherPP &&
          this.state.otherPP.length &&
          this.state.otherPP.map(item => {
            return item.otherPP;
          });
        updateParentState("otherPP", _otherPP);
        updateParentStateError("otherPP", this.state.error);
      }
    );
  };

  onChange = (value, key, index) => {
    const { updateParentState, updateParentStateError } = this.props;

    this.setState(prevState => {
      prevState.otherPP[index] = {
        ...prevState.otherPP[index],
        [key]: value
      };
      let _otherPP =
        prevState.otherPP &&
        prevState.otherPP.length &&
        prevState.otherPP.map(item => {
          return item.otherPP;
        });
      updateParentState("otherPP", _otherPP);
      updateParentStateError("otherPP", prevState.error);
      return {
        otherPP: [...prevState.otherPP],
        error: [...prevState.error]
      };
    });
  };

  onAutoSuggestChange = async (value, index, statepmgdeptusers) => {
    this.setState({ index: index });
    let _autoSuggestApiLoading = this.state.autoSuggestApiLoading;
    let _defaultSelected = this.state.defaultSelected;
    let _options = this.state.options;
    _autoSuggestApiLoading[index] = STATUS.LOADING;
    _defaultSelected[index] = value.searchedText;
    _options[index] = [];
    const { otherPP } = this.state;
    const { projectId } = this.props;

    if (value.searchedText === "") {
      let params =
        otherPP[index] && otherPP[index].otherPP && otherPP[index].otherPP.id;
      const isProjectDuplicateResp = params
        ? await shouldDeletePPAction(params, projectId)
        : { data: true };
      if (isProjectDuplicateResp && isProjectDuplicateResp.data) {
        this.onChange("", "otherPP", index);
      } else {
        let obj =
          otherPP[index] && otherPP[index].otherPP && otherPP[index].otherPP;
        this.onOptionClick(obj, index);
        toast.error(
          <p className="toast-text-alignment">
            User cannot be deleted.Contains related data
          </p>,
          errorToastStyle
        );
      }
    }
    this.setState({
      autoSuggestApiLoading: _autoSuggestApiLoading,
      defaultSelected: _defaultSelected,
      options: _options,
      key: Math.random()
    });
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(async () => {
      if (statepmgdeptusers) {
        const resp = await getAutoCompleteListUserAction(
          undefined,
          value.searchedText
        );
        if (resp) {
          if (get(resp, "status") && isValidArray(get(resp, "data"))) {
            let _autoSuggestApiLoading = this.state.autoSuggestApiLoading;
            let _options = this.state.options;
            _autoSuggestApiLoading[index] = STATUS.SUCCESS;
            _options[index] = get(resp, "data");
            this.setState({
              autoSuggestApiLoading: _autoSuggestApiLoading,
              options: _options,
              key: Math.random()
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
              errorToastStyle
            );
            let _autoSuggestApiLoading = this.state.autoSuggestApiLoading;
            let _options = this.state.options;
            _autoSuggestApiLoading[index] = STATUS.SUCCESS;
            _options[index] = [];
            const errorMessage = false;
            const updatedData = [...this.state.otherPP];
            if (index !== -1) {
              updatedData[index] = {
                ...updatedData[index],
                errorMessage
              };
            }
            this.setState({
              autoSuggestApiLoading: _autoSuggestApiLoading,
              options: _options,
              key: Math.random(),
              otherPP: updatedData
            });
          }
        }
      } else {
        const resp = await getAutoCompleteListAction(
          undefined,
          value.searchedText
        );

        if (resp) {
          if (get(resp, "status") && isValidArray(get(resp, "data"))) {
            let _autoSuggestApiLoading = this.state.autoSuggestApiLoading;
            let _options = this.state.options;
            _autoSuggestApiLoading[index] = STATUS.SUCCESS;
            _options[index] = get(resp, "data");
            this.setState({
              autoSuggestApiLoading: _autoSuggestApiLoading,
              options: _options,
              key: Math.random()
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{ERROR_MSG.NO_DATA_FOUND}</p>,
              errorToastStyle
            );
            let _autoSuggestApiLoading = this.state.autoSuggestApiLoading;
            let _options = this.state.options;
            _autoSuggestApiLoading[index] = STATUS.SUCCESS;
            _options[index] = [];
            const errorMessage = false;
            const updatedData = [...this.state.otherPP];
            if (index !== -1) {
              updatedData[index] = {
                ...updatedData[index],
                errorMessage
              };
            }
            this.setState({
              autoSuggestApiLoading: _autoSuggestApiLoading,
              options: _options,
              key: Math.random(),
              otherPP: updatedData
            });
          }
        }
      }
    }, 0);
    this.autoSuggestApi();
  };

  onOptionClickStatepmg = (value, index) => {
    let _defaultSelected = this.state.defaultSelected;
    this.setState({ clickflag: true }, () => {
      this.OtherPPBlur(value.name, this.state.clickflag);
    });
    _defaultSelected[index] = `${value.name} (${value.organization})`;
    const cleanedData = this.state.otherPP.map((item, i) => {
      if (i === index) {
        // Destructure to remove errorMessage ONLY at the matched index
        const { errorMessage, ...rest } = item;
        return rest;
      }
      return item;
    });
    this.setState({
      defaultSelected: _defaultSelected,
      key: Math.random(),
      otherPP: cleanedData,
      index: ""
    });
    this.onChange(value, "otherPP", index);
  };
  onOptionClick = (value, index) => {
    let _defaultSelected = this.state.defaultSelected;
    this.setState({ clickflag: true }, () => {
      this.OtherPPBlur(value.name, this.state.clickflag);
    });
    _defaultSelected[index] = `${value.name} (${value.userID})`;
    const cleanedData = this.state.otherPP.map((item, i) => {
      if (i === index) {
        // Destructure to remove errorMessage ONLY at the matched index
        const { errorMessage, ...rest } = item;
        return rest;
      }
      return item;
    });
    this.setState({
      defaultSelected: _defaultSelected,
      key: Math.random(),
      otherPP: cleanedData,
      index: ""
    });
    this.onChange(value, "otherPP", index);
  };
  OtherPPBlur = (value, clickflag) => {
    const { defaultSelected, otherPP, index } = this.state;
    const { OtherPPBlur: triggerBlur } = this.props; // Renaming to avoid conflict
    const errorMessage = "Invalid User";
    const updatedData = otherPP.map((item, i) => {
      let updatedItem = item;
      if (item.errorMessage === false) {
        updatedItem = {
          ...item,
          errorMessage
        };
        if (typeof triggerBlur === "function") triggerBlur(true);
      } else if (i === index && item.otherPP !== "" && !clickflag) {
        updatedItem = {
          ...item,
          errorMessage
        };
        if (typeof triggerBlur === "function") triggerBlur(true);
      } else if (i === index && item.otherPP === "" && value !== "") {
        updatedItem = {
          ...item,
          errorMessage
        };
        if (typeof triggerBlur === "function") triggerBlur(true);
      } else if (item.otherPP === "" && item.errorMessage) {
        const { errorMessage, ...rest } = item;
        updatedItem = rest;
      } else {
        if (typeof triggerBlur === "function") triggerBlur(false);
      }
      return updatedItem;
    });

    const hasErrorMessage = updatedData.some(item =>
      item.hasOwnProperty("errorMessage")
    );

    if (hasErrorMessage && typeof triggerBlur === "function") {
      triggerBlur(true);
    }
    this.setState({ otherPP: updatedData });
  };

  proponentBlur = value => {};
  render() {
    const {
      otherPP,
      autoSuggestApiLoading,
      options,
      defaultSelected,
      key,
      redBorder,
      otherPPerror
    } = this.state;

    const { isStateDepartment, isStatePMG, additionalPP } = this.props;
    const template = otherPP.map((param, index) => {
      const error = param.errorMessage || "";
      return (
        <React.Fragment>
          <div className={`added-location-wrapper added-date-wrapper`}>
            <div className="added-location-detail">
              <div className="location-name">
                <Form.Group className="field-mscb">
                  <AutoSuggestSelect
                    isLoading={autoSuggestApiLoading[index]}
                    defaultSelected={defaultSelected[index]}
                    name="projectAutoSuggest"
                    index={index}
                    id={`search-api-element-${index}`}
                    options={options[index] || []}
                    onChange={e => {
                      if (isStateDepartment || isStatePMG) {
                        this.onAutoSuggestChange(e, index, true);
                      } else {
                        this.onAutoSuggestChange(e, index, false);
                      }
                    }}
                    onOptionClick={e =>
                      isStateDepartment || isStatePMG
                        ? this.onOptionClickStatepmg(e, index)
                        : this.onOptionClick(e, index)
                    }
                    isStateDepartment={isStateDepartment}
                    isStatePMG={isStatePMG}
                    redBorder={redBorder}
                    error={error}
                    onBlur={this.proponentBlur}
                    OtherPPBlur={this.OtherPPBlur}
                    additionalPP={additionalPP}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className={error ? "error-show" : ""}
                  >
                    {error}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
            {otherPP && otherPP.length ? (
              index === 0 ? (
                otherPP.length && otherPP.length < 10 ? (
                  <div
                    className="btn-icon add-more"
                    title="Add Other PP"
                    onClick={this.onAddPP}
                  >
                    +
                  </div>
                ) : (
                  <div
                    className="btn-icon delete-location"
                    title="Delete"
                    onClick={() => {
                      this.onRemovePP(index);
                    }}
                  />
                )
              ) : (
                <div
                  className="btn-icon delete-location"
                  title="Delete"
                  onClick={() => {
                    this.onRemovePP(index);
                  }}
                />
              )
            ) : null}
          </div>
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <div className="added-location">{template}</div>
      </React.Fragment>
    );
  }
}

export default OtherPP;
